/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import { Tabs } from 'antd-mobile'
import { Models } from 'rmc-tabs/lib/Models'
import { observer } from 'mobx-react'
// css
import { CenterTabWrap } from '@styles/base.style'
import BeginnersGuide from '@views/Guide/BeginnersGuide'
import TipList from '../TipList'
import useRootStore from '@store/useRootStore'

export enum GUIDE_TAB_KEY {
  TIP = 'tip',
  GUIDE = 'guide',
}

const GuideTab: React.FC = () => {
  const { logStore } = useRootStore()
  const [currentIndex, setCurrentIndex] = useState(0)
  const [currentTabKey, setCurrentTabKey] = useState(GUIDE_TAB_KEY.TIP)

  const guideTabs = [
    {
      title: <span className="match-tab-txt">승부사 TIP</span>,
      name: '승부사 TIP',
      key: GUIDE_TAB_KEY.TIP,
    },
    {
      title: <span className="live-txt match-tab-txt">입문 가이드</span>,
      name: '입문 가이드',
      key: GUIDE_TAB_KEY.GUIDE,
    },
  ]

  const tabChanged = (tab: Models.TabData, index: number) => {
    if (tab.key === GUIDE_TAB_KEY.GUIDE) {
      logStore.writeButtonLog({ pageId: 'a060', buttonId: '002' }).catch(console.error)
    }
    setCurrentTabKey(tab.key as GUIDE_TAB_KEY)
    setCurrentIndex(index)
  }

  let contents: React.ReactElement
  if (currentTabKey === GUIDE_TAB_KEY.TIP) {
    contents = <TipList/>
  } else {
    contents = <BeginnersGuide/>
  }

  return (
    <Fragment>
      <CenterTabWrap className="guide-tab">
        <Tabs tabs={guideTabs} initialPage={currentIndex} page={currentIndex} onChange={tabChanged}/>
      </CenterTabWrap>
      {contents}
    </Fragment>
  )
}

export default observer(GuideTab)
